'use client';

import {
	Box, ButtonGroup, Stack, Text,
} from '@chakra-ui/react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { images } from '@/constants/images';
import { AppRoutes, getRoute } from '@/constants/route';
import { NextLinkButton } from '@/modules/navigation';

export const RegistrationComplete = () => {
	const t = useTranslations('authentication.registration.complete');

	return (
		<Stack gap="md">
			<Box aspectRatio="square" pos="relative" w="70%">
				<Image {...images.hero.registerComplete} fill style={{  objectFit: 'contain' }} />
			</Box>
			<Text textAlign="center" textStyle="h3">
				{t('message')}
			</Text>
			<ButtonGroup display="flex" flexDir="column" gap="md">
				<NextLinkButton href={AppRoutes.jobs.search} size="lg" w="full">
					{t('actions.start')}
				</NextLinkButton>
				<NextLinkButton href={getRoute.profile.index()} size="lg" variant="outline" w="full">
					{t('actions.updateProfile')}
				</NextLinkButton>
			</ButtonGroup>
			<Text textAlign="center" textStyle="body2">
				{t('helperText')}
			</Text>
		</Stack>
	);
};
